const PauseIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
  >
    <path
      d="M11 20V7C11 6.44772 10.5523 6 10 6H7C6.44772 6 6 6.44772 6 7V20C6 20.5523 6.44772 21 7 21H10C10.5523 21 11 20.5523 11 20Z"
      className={props.className}
      fill="currentColor"
    />
    <path
      d="M15 20V7C15 6.44772 15.4477 6 16 6H19C19.5523 6 20 6.44772 20 7V20C20 20.5523 19.5523 21 19 21H16C15.4477 21 15 20.5523 15 20Z"
      fill="currentColor"
      className={props.className}
    />
  </svg>
);

export default PauseIcon;
